import React, { FC } from "react";
import "./PolishLoadingSparkles.scss";

export interface PolishLoadingSparklesProps {
  text?: string;
  size?: number;
}

/**
 * 通用 AI 处理中加载态：
 * 5 颗 sparkle（4 卫星 + 1 中心），中心带 halo 光晕。
 * opacity + scale 错时闪烁，非旋转 spinner。
 * 颜色固定为 indigo（#6366f1 / #818cf8），避免组件变成万能配置。
 */
const SPARKLE_PATH =
  "m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z";

export const PolishLoadingSparkles: FC<PolishLoadingSparklesProps> = ({
  text,
  size = 96,
}) => (
  <div className="pls-root" aria-hidden style={{ width: size, height: size }}>
    <svg className="pls-sparkle pls-sparkle--1" viewBox="0 0 24 24">
      <path d={SPARKLE_PATH} />
    </svg>
    <svg className="pls-sparkle pls-sparkle--2" viewBox="0 0 24 24">
      <path d={SPARKLE_PATH} />
    </svg>
    <svg className="pls-sparkle pls-sparkle--3" viewBox="0 0 24 24">
      <path d={SPARKLE_PATH} />
    </svg>
    <svg className="pls-sparkle pls-sparkle--4" viewBox="0 0 24 24">
      <path d={SPARKLE_PATH} />
    </svg>
    <span className="pls-center-halo" />
    <svg className="pls-sparkle pls-sparkle--center" viewBox="0 0 24 24">
      <path d={SPARKLE_PATH} />
    </svg>
    {text && <span className="pls-text">{text}</span>}
  </div>
);